import React, { useState, useEffect } from 'react';
import './Slider.css';

interface SliderProps {
  minValue?: number;
  maxValue?: number;
  step?: number;
  initialValue?: number;
  onChange: (value: number) => void;
  onPointerDown?: () => void;
  onPointerUp?: () => void;
}

const Slider: React.FC<SliderProps> = ( { minValue = 0, maxValue = 1, step = 0.01, initialValue = 0, onChange, onPointerDown, onPointerUp }) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(event.target.value);
    console.log('slider new val: ', newValue);
    onChange(newValue);
    setValue(newValue);
  };

  const handleMouseUp = (event: React.MouseEvent<HTMLInputElement>) => {
    (event.target as HTMLInputElement).blur();
    onPointerUp && onPointerUp();
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLInputElement>) => {
    onPointerDown && onPointerDown();
  };

  return (
    <div className="slider-holder">
        <input
          type="range"
          min={minValue}
          max={maxValue}
          step={step}
          value={value}
          onChange={handleChange}
          onMouseUp={handleMouseUp}
          onMouseDown={handleMouseDown}
        />
    </div>
  );
};

export default Slider;
